module.exports = __webpack_public_path__ + "img/farm.717f4d8c.png";